import axios from 'axios';

const state = () => ({
 session: {
  defaultLangCode: 'en',
  defaultLangId: 1,
  languageCode: null,
  languageId: null,
  userSession: null,
  profileUserSession: null,
  imageUrl: null
 }
});

const mutations = {
 setLang(state, session) {
  state.session.languageCode = session.languageCode
  state.session.languageId = session.languageId
 },
 async getLang(state) {
  const response = await this.getApi('/api/v1/langs/current')
  state.session.languageCode = response.languageCode
  state.session.languageId = response.languageId
 },
 setUser(state, session) {
   state.session.userSession = session;
 },
 getUser(state) {
    return state.session.userSession;
 },
 setProfile(state, profile) {
   state.session.profileUserSession = profile; 
 },
 getProfile(state) {
    return state.session.profileUserSession;
 },
 setImageUrl(state,url) {
    return state.session.imageUrl = url;
 }
}

const actions = {
 async setLang(context) {
  const response = await this.getApi('/api/v1/langs/current')

  const session = {
   languageCode: response.languageCode,
   languageId: response.languageId
  }
  context.commit('setLang', session)
 },
 async setUser(context) {
     const { state } = context;
     const user = state.session.userSession;
     if(!user) {
        const response = await axios.get(`${process.env.VUE_APP_ROOT}/laravel/public/api/v1/users/current`);
        if(response && response.data && response.data.success) {
           context.commit("setUser", response.data.message);
           context.dispatch('setImageUrl');
        }
     }
 },
 async setProfile(context) {
      const { state } = context;
      const user = state.session.userSession;
      const profileUser = state.session.profileUserSession;
      
      if(!user) {
         context.dispatch('setUser');
      } else if(!profileUser) {
      
      const response = await axios.get(`${process.env.VUE_APP_ROOT}/laravel/public/api/v1/promoter/profile/${user.id}`);
      if(response && response.data && response.data.success) {
         context.commit("setProfile", response.data.message);
      }
    }
 },
 setImageUrl(context) {
   const { state } = context;
   const user = state.session.userSession;
   let imageUrl = user.existFile
      ? process.env.VUE_APP_ROOT + "/laravel/public" + user.image
      : process.env.VUE_APP_ROOT + user.image;
   context.commit('setImageUrl',imageUrl);
 }
}

export default {
 state, mutations, actions
}